import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { MCPConfigSnippet } from '../../../../src/components/Product/MCP/MCPConfig';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <ol>
      <li parentName="ol">{`Open `}<a parentName="li" {...{
          "href": "http://claude.ai/download"
        }}>{`Claude Desktop`}</a>{` and navigate to `}<strong parentName="li">{`Settings > Developer`}</strong></li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Edit Config`}</strong>{` to open the configuration file`}</li>
      <li parentName="ol">{`Update `}<inlineCode parentName="li">{`claude_desktop_config.json`}</inlineCode>{` with the following configuration:`}</li>
    </ol>
    <MCPConfigSnippet variant="claude-desktop" mdxType="MCPConfigSnippet" />
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol"><strong parentName="li">{`Save`}</strong>{` the configuration file and `}<strong parentName="li">{`restart Claude Desktop`}</strong></li>
      <li parentName="ol">{`The MCP server should show as `}<strong parentName="li">{`PostHog`}</strong>{` in your list of Connectors found in `}<strong parentName="li">{`Settings > Connectors`}</strong></li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      